<h2 mat-dialog-title>{{'dialogs.terms_of_use.title' | translate}}</h2>
<mat-dialog-content fxLayout="column nowrap">
  <div [innerHTML]="'dialogs.terms_of_use.content' | translate"></div>
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-actions fxLayout="row nowrap" fxLayoutAlign="end center">
  <button mat-button mat-dialog-close>{{'keys.local.global.close' | translate}}</button>
</mat-dialog-actions>
